export class CertificateEntity {
  public fileHash: string;
  public identifier: string;
  public issuedAt: Date;
}
